import { ToolFilled } from '@ant-design/icons'
import Link from 'next/link'
import { NextRouter, useRouter } from 'next/router'
import React from 'react'

import { SiderMenuItem } from './SiderMenuItem'
import { getMenuItem, MenuItem } from '@/components/ui/common/MenuItem'
import urls from '@/config/uiUrls'
import { useWorkspaceContext } from '@/context/WorkspaceContext'
import { IntlFunction } from '@/utils/messages'
import { isClaytonWorkspaceAdmin } from '@/utils/workspaces'

import { Workspace } from '@/types/index.d'

export function SettingsSubMenu(
  baseUrl: string,
  setPaywallModalComponentId: (id: any) => void,
  t: IntlFunction,
  componentId: `SiderMenu`
) {
  const { workspace: currentWorkspace, user } = useWorkspaceContext()

  const router = useRouter()

  return getMenuItem(t(`${componentId}.settings`), 'settings', <ToolFilled />, [
    isClaytonWorkspaceAdmin(user, currentWorkspace) &&
      SettingSubMenuItem(
        urls.settings.packages,
        t(`${componentId}.settings.packages`),
        'settings-packages'
      ),
    SettingSubMenuItem(
      urls.settings.policies,
      t(`${componentId}.settings.policies`),
      'settings-policies'
    ),
    CustomRuleBuilderMenuItem(
      urls.settings.rules,
      setPaywallModalComponentId,
      t,
      currentWorkspace,
      router
    ),
    SettingSubMenuItem(
      urls.settings.usage,
      t(`${componentId}.settings.usage`),
      'settings-usage'
    ),
  ])
}

function SettingSubMenuItem(
  baseUrl: string,
  label: React.ReactNode,
  menuItemKey: string
): MenuItem & { 'data-cy': string } {
  return {
    'data-cy': `SiderMenu.${menuItemKey}`,
    ...getMenuItem(
      <Link href={baseUrl} passHref>
        <span className="menu-item-title">{label}</span>
      </Link>,
      menuItemKey
    ),
  }
}

function CustomRuleBuilderMenuItem(
  baseUrl: string,
  setPaywallModalComponentId: (id: any) => void,
  t: IntlFunction,
  currentWorkspace: Workspace,
  router: NextRouter
): MenuItem {
  return SiderMenuItem({
    feature: 'rule_builder',
    href: baseUrl,
    key: 'settings-rules',
    router,
    showPaywallModal: setPaywallModalComponentId,
    t,
    workspace: currentWorkspace,
  })
}
